const launcher = document.querySelector("[data-intercom-launcher]");
const mobileQuery = window.matchMedia("(max-width: 639.98px)");

if (launcher) {
  const hideDefaultIntercomLauncher = () => {
    if (typeof window.Intercom !== "function") {
      return false;
    }

    window.Intercom("update", {
      hide_default_launcher: true,
    });

    return true;
  };

  function syncIntercomLauncher() {
    if (hideDefaultIntercomLauncher()) {
      return;
    }

    let attempts = 0;

    const interval = setInterval(() => {
      attempts += 1;

      if (hideDefaultIntercomLauncher() || attempts >= 10) {
        clearInterval(interval);
      }
    }, 500);
  }

  launcher.addEventListener("click", () => {
    if (typeof window.Intercom === "function") {
      window.Intercom("show");
    }
  });

  if (document.readyState === "complete") {
    syncIntercomLauncher();
  } else {
    window.addEventListener("load", syncIntercomLauncher, {
      once: true,
    });
  }

  let stickyBar = null;
  let stickyBarResizeObserver = null;
  let stickyBarClassObserver = null;

  const updateLauncherPosition = () => {
    if (!stickyBar) {
      return;
    }

    const shouldMoveAboveSticky =
      mobileQuery.matches &&
      stickyBar.classList.contains("sticky-atc-bar--show");

    const barHeight = stickyBar.getBoundingClientRect().height;

    launcher.style.setProperty("--sticky-atc-height", `${barHeight}px`);

    launcher.classList.toggle(
      "custom-intercom-launcher--above-sticky",
      shouldMoveAboveSticky,
    );
  };

  const bindStickyBar = () => {
    const newStickyBar = document.querySelector(".sticky-atc-bar");

    if (!newStickyBar || newStickyBar === stickyBar) {
      return;
    }

    stickyBarResizeObserver?.disconnect();
    stickyBarClassObserver?.disconnect();

    stickyBar = newStickyBar;

    if ("ResizeObserver" in window) {
      stickyBarResizeObserver = new ResizeObserver(updateLauncherPosition);
      stickyBarResizeObserver.observe(stickyBar);
    }

    stickyBarClassObserver = new MutationObserver(updateLauncherPosition);
    stickyBarClassObserver.observe(stickyBar, {
      attributes: true,
      attributeFilter: ["class"],
    });

    updateLauncherPosition();
  };

  if (!("ResizeObserver" in window)) {
    window.addEventListener("resize", updateLauncherPosition);
  }

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener("change", updateLauncherPosition);
  } else {
    // Legacy Safari fallback.
    mobileQuery.addListener(updateLauncherPosition);
  }

  bindStickyBar();

  const stickySection = document.getElementById(
    "shopify-section-sticky-atc-bar",
  );

  if (stickySection?.parentNode) {
    new MutationObserver(bindStickyBar).observe(stickySection.parentNode, {
      childList: true,
    });
  }
}
